export default __webpack_public_path__ + "static/media/groupAvatar.68043f8f.png";